/**
 * @file blog-cover-options.ts
 * @description Реестр вариантов обложки встроенной шапки ленты блога
 * (решение пользователя 2026-10-12): подпись карточки-схемы в «Как показать
 * обложку» и слово для сводки группы «Шапка ленты». Отдельный файл — чтобы
 * поле (`BlogCoverFields`) и сводка (`BlogFeedTab`) брали один список.
 */

import type { SiteBlogOptions } from "@chaiberi/shared";

export const COVER_LAYOUTS: ReadonlyArray<{ value: SiteBlogOptions["coverLayout"]; label: string; short: string }> = [
  { value: "background", label: "Фоном во всю ширину", short: "обложка фоном" },
  { value: "side-right", label: "Картинкой справа", short: "картинка справа" },
  { value: "side-left", label: "Картинкой слева", short: "картинка слева" },
];

/** Пояснение к неактивным фокусу, затемнению и тону при картинке сбоку. */
export const COVER_SIDE_NOTE = "Действуют только при обложке фоном.";
